






import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Condition as ConditionEnum, Building as BuildingEnum, Operator as OperatorEnum } from "@gaia-project/engine";

@Component({
  components: {},
})
export default class Operator extends Vue {
  @Prop()
  condition!: ConditionEnum;

  @Prop()
  operator: OperatorEnum;

  get isTrigger() {
    return this.operator === OperatorEnum.Trigger;
  }
}
